module.exports = __webpack_public_path__ + "static/media/RM_blob_click_here.c97e0a3d.png";